<template>
  <div class="step4">
    <div class="input-con">
    <table class="input-table">
      <tr>
        <td>Special Instructions:</td>
      </tr>
      <tr>
        <td>
          <div class="w-full p-2 flex rounded-md shadow-sm">
            <editor
              api-key="skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4"
              :init="{
              height: 300,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help'
              }"
              v-model="specialInstructions"
            />
          </div>
        </td>
      </tr>
    </table>
    </div>
    <div class="button-con">
      <CButton color="green" text="Next"  @click="onNextClick"/>
      <div class="ml20">
        <CButton color="orange" text="Back" @click="onBack"/>
      </div>
      <div class="ml20">
        <CButton color="red" text="Cancel"  @click="onCancel"/>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import CButton from "../common/CButton.vue";
import CSwitch from "../common/CSwitch.vue";

export default {
  name: 'Steps4',
  components:{
    Editor,
    CButton,
    CSwitch
  },
  props: {
    onNext: Function,
    onBack: Function,
    onCancel: Function,
  },
  data(){
    return{
      specialInstructions: ''
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    onNextClick(){
      this.onNext({
        specialInstructions: this.specialInstructions
      })
    }
  }
}
</script>